module.exports = __webpack_public_path__ + "img/GAME_GETTHENUMBERDISH1.328bfb9c.jpg";